/*
 *  instead of having `window.location.href = 'somevalue'` scattered throughout
 *  our code, we are using this function because it is easy to mock, and because
 *  jsdom@11 doesn't allow us to set `window.location.href`.  Also, we can't
 *  use window.location.assign() because the following error is thrown on cancelFlow:
 *  `DOMException: Permission denied to access property "assign" on cross-origin object`
 *  we are keeping this function in a file by itself, so it is easy to mock in
 *  all our test cases.
 */
const setUrl = (win, href) => {
    win.location.href = href;
};

export default setUrl;
